
import { Component, Prop, Vue } from "vue-property-decorator";
import WidgetData from "@/interfaces/dashboard/WidgetData";

@Component
export default class DataTable extends Vue {
  @Prop({ default: {} })
  public widgetData: WidgetData;

  @Prop()
  public height: number;
}
